import { render, staticRenderFns } from "./DataItemInfo.vue?vue&type=template&id=e88246b0&scoped=true&"
import script from "./DataItemInfo.vue?vue&type=script&lang=ts&"
export * from "./DataItemInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DataItemInfo.vue?vue&type=style&index=0&id=e88246b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88246b0",
  null
  
)

export default component.exports